import { Link } from 'gatsby';
import React from 'react';

import Logo from '../Logo/Logo';
import TemporaryDrawer from '../Sidebar/Sidebar';

import './style.css';


const Header = () => {
  return (
    <header className="relative z-10">
      <div className="my-0 mx-auto max-w-7xl py-4 px-5 flex items-center">
        <Link to="/" className="top-0 block max-w-xs md:text-4xl scale">
          <Logo />
        </Link>
        <div className="hidden ml-auto flex items-center md:block">
          <Link to="/" activeClassName="active" className="top-0 mr-8 text-gray-700 text-base">
            ¿Qué es factoraje financiero?
          </Link>
          <Link to="/inversionistas/" activeClassName="active" className="top-0 mr-8 text-gray-700 text-base">
            Inversionistas
          </Link>
          <Link to="/deudores/" activeClassName="active" className="top-0 mr-8 text-gray-700 text-base">
            Deudores
          </Link>
          <Link to="/factorados/" activeClassName="active" className="top-0 mr-8 text-gray-700 text-base">
            Factorados
          </Link>
          <a href="https://blog.fondimex.com/" activeClassName="active" className="top-0 mr-8 text-gray-700 text-base">
            Blog
          </a>
          <a href={process.env.GATSBY_APP_URL} activeClassName="active" className="top-0">
            <button className="bg-green-200 text-white px-6 py-3 rounded-lg inline-block px-10" >
              Iniciar sesión
            </button>
          </a>
        </div>
        <TemporaryDrawer />
      </div>
    </header>
  );
};

export default Header;
